import {Component, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {Image} from "../../../interface/image";
import {isEmptyString} from "bmx-pastebox";
import {ImageService} from "../../service/image.service";
import {ImageGallerySeo} from "../../interface/image-gallery-seo";

@Component({
	selector: 'fb-product-big-image',
	templateUrl: './product-big-image.component.html',
	styleUrls: ['./product-big-image.component.scss']
})
export class ProductBigImageComponent implements OnInit {

	@Input() imageGallery: ImageGallerySeo[] = [];
	@Input() video: Image = {} as Image;
	@Input() addOnImagePassOn: string = '';

	public videoUrl: string = '';
	public safeURL: SafeResourceUrl = '';

	constructor(
		private _sanitizer: DomSanitizer,
		private _image: ImageService
	) {
	}

	public ngOnInit(): void {
		if (!isEmptyString(this.video.url)) {
			this.videoUrl = this._image.getEmbeddedURL(this.video.url);
			this.safeURL = this._sanitizer.bypassSecurityTrustResourceUrl(this.videoUrl);
			// this.imageGallery.splice(1, 0, { image: this.video.url, altText: this.video.altText, deleted: false });
			this.imageGallery = [...new Set(this.imageGallery)]
		}
	}
}
